import * as CompletionTypes from '../CompletionTypes';

export default (element) => {
  const text = element.getText();
  if (text === '$') {
    return [
      { type: CompletionTypes.PARAMETER },
    ];
  }
  return [];
};



// WEBPACK FOOTER //
// ./node_modules/cypher-editor-support/src/completion/rules/ruleParamStartsWithDollar.js